
import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';

export const useProviderAccess = (providerId?: string) => {
  const { user } = useAuth();
  const [isProviderViewing, setIsProviderViewing] = useState(false);

  // Query for provider access data
  const { data: providerAccess, isLoading } = useQuery({
    queryKey: ['provider-access', user?.id],
    queryFn: async () => {
      if (!user) return null;
      
      const { data, error } = await supabase
        .from('user_provider_assignments')
        .select('*')
        .eq('user_id', user.id)
        .single();
      
      if (error) {
        // User doesn't have provider access
        return null;
      }
      
      return data;
    },
    enabled: !!user,
  });

  // Check if user is viewing as provider for specific provider
  useEffect(() => {
    const checkProviderAccess = async () => {
      if (!user || !providerId) return;
      
      try {
        const { data: assignment } = await supabase
          .from('user_provider_assignments')
          .select('id')
          .eq('user_id', user.id)
          .eq('provider_id', providerId)
          .single();
        
        setIsProviderViewing(!!assignment);
      } catch (error) {
        // User doesn't have provider access, keep as customer view
        setIsProviderViewing(false);
      }
    };
    
    checkProviderAccess();
  }, [user, providerId]);

  return { 
    data: providerAccess,
    isLoading,
    isProviderViewing 
  };
};
